<template>
  <v-autocomplete
    autocomplete="off"
    prepend-icon="mdi-magnify"
    :label="$t('tag.decoder')"
    v-model="currentDecoder"
    :items="decoders"
    item-text="name"
    item-value="value"
  ></v-autocomplete>
</template>

<script>
import DecoderHelper from "@/_helpers/DecoderHelper";

export default {
  name: "DecoderSelect",
  props: ["decoder"],
  data() {
    return {
      currentDecoder: "",
      decoders: DecoderHelper.decoders,
    };
  },

  mounted() {
    this.currentDecoder = this.decoder;
  },

  watch: {
    currentDecoder(newVal) {
      this.$emit("update-value", newVal);
    },

    decoder() {
      this.currentDecoder = this.decoder;
    },
  },
};
</script>
